import "./LocaleSwitch.scss"
import React, {useCallback, useEffect} from "react";
import {Select} from "antd";
import {useCookies} from "react-cookie";
import {useTranslation} from "react-i18next";
import {COOKIE} from "@tools/constants";
import defaultSettings from "@resources/defaultSettings";
const langCookieName = COOKIE.LANG

const LocaleSwitch: React.FC = () => {
    const [cookies, setCookie] = useCookies([langCookieName])
    const { t } = useTranslation();

    const onLocaleChange = useCallback((lang: string) => {
        setCookie(langCookieName, lang, {path: "/", maxAge: 60 * 60 * 24 * 365 });
        window.location.reload();

    }, [setCookie]);

    useEffect(() => {
        if (!cookies[langCookieName])
            onLocaleChange(defaultSettings.lang)
    }, [cookies[langCookieName], onLocaleChange])

    if (defaultSettings.languages.length < 2)
        return null

    return <Select className="localeSwitch" value ={cookies[langCookieName]} onChange={onLocaleChange}>
        {defaultSettings.languages.map(lang => <Select.Option key={lang} value={lang}>{t(`lookup:languages.${lang}`)}</Select.Option>)}
    </Select>
};

export default  LocaleSwitch;

